let ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
let BOA_URLS = {};

switch (ENV) {
  case 'development':
  case 'sandbox':
  case 'test':
    BOA_URLS = {
      faqDocUrl:
        'https://s3.amazonaws.com/farmers-qa-host/docs/chubb/p360/common/marketing/chubb_p360_faq.pdf',
      planOverviewUrl:
        'https://s3.amazonaws.com/farmers-qa-host/docs/chubb/boa/common/marketing/chubb_boa_brochure.pdf',
    };
    break;
  case 'production':
    BOA_URLS = {
      faqDocUrl:
        'https://s3.amazonaws.com/farmers-qa-host/docs/chubb/p360/common/marketing/chubb_p360_faq.pdf',
      planOverviewUrl:
        'https://s3.amazonaws.com/farmers-qa-host/docs/chubb/boa/common/marketing/chubb_boa_brochure.pdf',
    };
    break;
  default:
    break;
}

export default BOA_URLS;
